<template>
  <div>
    <div class="foot-box">
      <div class="top-txt">
        经营性网站备案信息  |  中国互联网举报中心  |  网络110报警服务
      </div>
      <el-divider></el-divider>
      <div class="foot-txt">
        Copyright © 建成工程咨询股份有限公司
      </div>
      <!--<div class="foot-txt">
        粤ICP备09217733号 粤123456789号 粤公网安备123456789号
      </div>-->
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    methods: {

    },
  }
</script>

<style lang="scss" scoped>
.foot-box {
  width: 100%;
  text-align: center;
  padding: 20px 0;
  background: #333333;
  .top-txt {
    font-size: 14px;
    color: #FFFFFF;
  }
  .foot-txt {
    color: #A9A9A9;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageFooter.vue